import React from 'react';

export const FlagGray300Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_8892_875)">
        <path
          d="M14.0799 8.47199L11.9679 5.86399L14.0799 3.25599C14.4479 2.79999 14.5199 2.18399 14.2719 1.65599C14.0239 1.12799 13.4959 0.791992 12.9039 0.791992H3.01591C2.18391 0.791992 1.50391 1.47199 1.50391 2.30399V14.392C1.50391 14.832 1.86391 15.192 2.30391 15.192C2.74391 15.192 3.10391 14.832 3.10391 14.392V10.928H12.9039C13.4959 10.928 14.0159 10.6 14.2719 10.064C14.5279 9.53599 14.4559 8.91999 14.0799 8.46399V8.47199ZM3.10391 9.33599V2.39999H12.7119L10.3119 5.35999C10.0719 5.65599 10.0719 6.07199 10.3119 6.36799L12.7119 9.32799H3.10391V9.33599Z"
          fill="#DCDCDC"
        />
      </g>
      <defs>
        <clipPath id="clip0_8892_875">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
